import { render, staticRenderFns } from "./ChristmasTree.vue?vue&type=template&id=90b150a6"
import script from "./ChristmasTree.vue?vue&type=script&lang=js"
export * from "./ChristmasTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports